import type { SeedListData } from '@openx/types/segments';

export const getInitialData = (data?: SeedListData[]) => {
  return {
    listData: data ?? [],
    baseListData: data ?? [],
  };
};
